import { httpClient } from '@/services/http/httpClient'

export async function finishWorkflow(id: string): Promise<void> {
  await httpClient.put(`/ideas/ideas/${id}/finished`)
}
